{
  "AUTOMATION": {
    "HEADER": "自動化",
    "DESCRIPTION": "自動化可以取代並簡化需要手動執行的現有流程，例如新增標籤和將對話指派給最合適的客服人員。這讓團隊能夠專注於核心工作，同時減少花在例行事務上的時間。",
    "LEARN_MORE": "瞭解更多關於自動化的資訊",
    "COUNT": "{n} 條自動化規則 | {n} 條自動化規則",
    "HEADER_BTN_TXT": "建立自動化",
    "LOADING": "正在載入自動化規則",
    "SEARCH_PLACEHOLDER": "搜尋自動化規則...",
    "NO_RESULTS": "找不到符合搜尋條件的自動化規則",
    "ADD": {
      "TITLE": "新增自動化規則",
      "SUBMIT": "建立",
      "CANCEL_BUTTON_TEXT": "取消",
      "FORM": {
        "NAME": {
          "LABEL": "規則名稱",
          "PLACEHOLDER": "輸入規則名稱",
          "ERROR": "名稱為必填"
        },
        "DESC": {
          "LABEL": "描述",
          "PLACEHOLDER": "輸入規則描述",
          "ERROR": "描述為必填"
        },
        "EVENT": {
          "LABEL": "事件",
          "PLACEHOLDER": "請選擇一項",
          "ERROR": "事件為必填"
        },
        "CONDITIONS": {
          "LABEL": "條件"
        },
        "ACTIONS": {
          "LABEL": "動作"
        }
      },
      "CONDITION_BUTTON_LABEL": "新增條件",
      "ACTION_BUTTON_LABEL": "新增動作",
      "API": {
        "SUCCESS_MESSAGE": "自動化規則已成功建立",
        "ERROR_MESSAGE": "無法建立自動化規則，請稍後再試"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "名稱",
        "ACTIVE": "啟用",
        "CREATED_ON": "建立時間",
        "ACTIONS": "操作"
      },
      "404": "找不到任何自動化規則"
    },
    "DELETE": {
      "TITLE": "刪除自動化規則",
      "SUBMIT": "刪除",
      "CANCEL_BUTTON_TEXT": "取消",
      "CONFIRM": {
        "TITLE": "確認刪除",
        "MESSAGE": "您確定要刪除嗎？ ",
        "YES": "是，刪除 ",
        "NO": "不，保留 "
      },
      "API": {
        "SUCCESS_MESSAGE": "自動化規則已成功刪除",
        "ERROR_MESSAGE": "無法刪除自動化規則，請稍後再試"
      }
    },
    "EDIT": {
      "TITLE": "編輯自動化規則",
      "SUBMIT": "更新",
      "CANCEL_BUTTON_TEXT": "取消",
      "API": {
        "SUCCESS_MESSAGE": "自動化規則已成功更新",
        "ERROR_MESSAGE": "無法更新自動化規則，請稍後再試"
      }
    },
    "CLONE": {
      "TOOLTIP": "複製",
      "API": {
        "SUCCESS_MESSAGE": "自動化規則已成功複製",
        "ERROR_MESSAGE": "無法複製自動化規則，請稍後再試"
      }
    },
    "FORM": {
      "EDIT": "編輯",
      "CREATE": "建立",
      "DELETE": "刪除",
      "CANCEL": "取消",
      "RESET_MESSAGE": "變更事件類型將會重置您在下方新增的條件與動作"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "您至少需要保留一個條件才能儲存",
      "CONTACT_CUSTOM_ATTR_LABEL": "聯絡人自訂屬性",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "對話自訂屬性"
    },
    "ACTION": {
      "DELETE_MESSAGE": "您至少需要保留一個動作才能儲存",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "在此輸入您的訊息",
      "TEAM_DROPDOWN_PLACEHOLDER": "選擇團隊",
      "EMAIL_INPUT_PLACEHOLDER": "輸入電子郵件",
      "URL_INPUT_PLACEHOLDER": "輸入 URL"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "啟用自動化規則",
      "DEACTIVATION_TITLE": "停用自動化規則",
      "ACTIVATION_DESCRIPTION": "此操作將啟用自動化規則「{automationName}」。您確定要繼續嗎？",
      "DEACTIVATION_DESCRIPTION": "此操作將停用自動化規則「{automationName}」。您確定要繼續嗎？",
      "ACTIVATION_SUCCESFUL": "自動化規則已成功啟用",
      "DEACTIVATION_SUCCESFUL": "自動化規則已成功停用",
      "ACTIVATION_ERROR": "無法啟用自動化規則，請稍後再試",
      "DEACTIVATION_ERROR": "無法停用自動化規則，請稍後再試",
      "CONFIRMATION_LABEL": "是",
      "CANCEL_LABEL": "否"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "無法上傳附件，請再試一次",
      "LABEL_IDLE": "上傳附件",
      "LABEL_UPLOADING": "上傳中...",
      "LABEL_UPLOADED": "上傳成功",
      "LABEL_UPLOAD_FAILED": "上傳失敗"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "屬性鍵值為必填",
      "FILTER_OPERATOR_REQUIRED": "篩選運算子為必填",
      "VALUE_REQUIRED": "值為必填",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "值必須介於 1 到 998 之間",
      "ACTION_PARAMETERS_REQUIRED": "動作參數為必填",
      "ATLEAST_ONE_CONDITION_REQUIRED": "至少需要一個條件",
      "ATLEAST_ONE_ACTION_REQUIRED": "至少需要一個動作"
    },
    "NONE_OPTION": "無",
    "LAST_RESPONDING_AGENT": "Last Responding Agent",
    "EVENTS": {
      "CONVERSATION_CREATED": "對話已建立",
      "CONVERSATION_UPDATED": "對話已更新",
      "MESSAGE_CREATED": "訊息已建立",
      "CONVERSATION_RESOLVED": "對話已解決",
      "CONVERSATION_OPENED": "對話已開啟"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "指派給客服人員",
      "ASSIGN_TEAM": "指派團隊",
      "REMOVE_ASSIGNED_AGENT": "移除已指派的客服人員",
      "REMOVE_ASSIGNED_TEAM": "移除已指派的團隊",
      "ADD_LABEL": "新增標籤",
      "REMOVE_LABEL": "移除標籤",
      "SEND_EMAIL_TO_TEAM": "傳送電子郵件給團隊",
      "SEND_EMAIL_TRANSCRIPT": "傳送電子郵件對話記錄",
      "MUTE_CONVERSATION": "將對話靜音",
      "SNOOZE_CONVERSATION": "暫停對話通知",
      "RESOLVE_CONVERSATION": "解決對話",
      "SEND_WEBHOOK_EVENT": "傳送 Webhook 事件",
      "SEND_ATTACHMENT": "傳送附件",
      "SEND_MESSAGE": "傳送訊息",
      "ADD_PRIVATE_NOTE": "新增私人備註",
      "CHANGE_PRIORITY": "變更優先順序",
      "ADD_SLA": "新增 SLA",
      "OPEN_CONVERSATION": "開啟對話",
      "PENDING_CONVERSATION": "將對話標記為待處理"
    },
    "MESSAGE_TYPES": {
      "INCOMING": "接收的訊息",
      "OUTGOING": "傳送的訊息"
    },
    "PRIORITY_TYPES": {
      "NONE": "無",
      "LOW": "低",
      "MEDIUM": "中",
      "HIGH": "高",
      "URGENT": "緊急"
    },
    "ATTRIBUTES": {
      "MESSAGE_TYPE": "訊息類型",
      "PRIVATE_NOTE": "私人筆記",
      "MESSAGE_CONTAINS": "訊息包含",
      "EMAIL": "電子郵件",
      "INBOX": "收件匣",
      "CONVERSATION_LANGUAGE": "對話語言",
      "PHONE_NUMBER": "電話號碼",
      "STATUS": "狀態",
      "BROWSER_LANGUAGE": "瀏覽器語言",
      "MAIL_SUBJECT": "郵件主旨",
      "COUNTRY_NAME": "國家",
      "COMPANY_NAME": "公司",
      "REFERER_LINK": "來源連結",
      "ASSIGNEE_NAME": "負責人",
      "TEAM_NAME": "團隊",
      "PRIORITY": "優先順序",
      "LABELS": "標籤"
    }
  }
}
